<template>
  <div class="page-effect">
    <!-- <section
      id="sectionId"
      class="ss-reg-top"
      style="background-color: #f1f3f4"
    > -->
    <div class="container-fluid border-bottom p-0 ss-reg-top">
      <div
        class="d-md-flex justify-content-end page-option-sticky sticky-without-menu ss-speaker-head-wrap"
        v-if="!isRegistrationComponent"
      >
        <!-- <v-btn dark color="#1a73e8" class="mr-3 mt-1" data-toggle="modal" data-target="#ChangeBannerModalCenter">Change Banner Image</v-btn> -->
        <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#welcomemailModalCenter"
          @click="
            $refs.reminderAnnounceMailPopup.templateReminder = 'Speaker';
            $refs.reminderAnnounceMailPopup.templateAnnouncement = null;
            $refs.reminderAnnounceMailPopup.getMailTemplate('Speaker');
          "
        >
          <v-icon color="#5f6368" size="18px" class="mr-1">mdi-email-outline</v-icon>
          Send Mail</a
        >
        <!-- <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#RegistrationtypeModal"
          ><v-icon color="#5f6368" size="18px" class="mr-1">mdi-cog-outline</v-icon>
          Advanced Settings</a
        > -->
        <a
          href="#"
          class="pt-3 left-effect2 d-none"
          data-toggle="modal"
          data-target="#CheckoutformypeModal"
          @click="openBulkUploadPopup()"
          ><v-icon color="#5f6368" size="18px" class="mr-1">mdi-tray-arrow-up</v-icon>
          Bulk Import</a
        >
        <v-btn
          class="my-2 mr-4 save-standard"
          outlined
          color="#2376e5"
          width="180px"
          @click="openSpeakerPopup()"
          ><v-icon class="mr-1" color="#2376e5" size="20px">mdi-plus</v-icon> Add New
          Speaker</v-btn
        >
        <!-- <v-btn dark class="mt-1 mr-4 ml-3" color="#1a73e8"><v-icon color="#ffffff" size="25px" class="mr-2">mdi-plus</v-icon> Add New Speaker</v-btn> -->
      </div>
      <div class="admin_speaker_list">
        <SpeakerList
          ref="speeakerList"
          :key="speeakerListKey"
          :isAdminComponent="isAdminComponent"
          :isRegistrationComponent="isRegistrationComponent"
          @OpenAddSpeakerPopup="OpenAddSpeakerPopup"
        >
        </SpeakerList>        
      </div>
    </div>
    <!-- </section> -->

    <SpeakerAddEdit
      v-if="speeakerAddEditDialog"
      :key="speeakerAddEditKey"
      :uid="uid"
      :clientId="clientId"
      :eventId="eventId"
      :event_collectionName="event_collectionName"
      :Speaker="Speaker"
      @OnAddSpeakerSuccess="OnAddSpeakerSuccess"
      @OnUpdateSpeakerSuccess="OnUpdateSpeakerSuccess"
    ></SpeakerAddEdit>

    <ReminderAnnounceMailPopup
      v-if="!isRegistrationComponent"
      ref="reminderAnnounceMailPopup"
    />
    <BulkUpload
      v-if="openBulkPopup && !isRegistrationComponent"
      :key="resetBulkUploadComponent"
      type="speaker"
    />

    <v-dialog
      max-width="600"
      scrollable
      v-model="speakerAddEditDialog"
      persistent
      content-class="modal-content"
      transition="scroll-x-reverse-transition"
      style=""
    >
      <v-card-text>
        <div class="modal-content">
          <div class="modal-body text-center">
            <img src="../assets/Images/reg-ico/success.png" alt="e2m" />
            <h2 class="my-5">The new speaker has been created successfully!</h2>
            <div class="ss-cns-foo-btn final-button mr-custom-class">
              <v-btn
                outlined
                large
                color="#1a73e8"
                class="mr-2"
                @click="CloseSuccess">
                <!-- <v-icon color="#1a73e8" size="20px" class="mr-4">mdi-arrow-left</v-icon> -->
                Close</v-btn>
              <v-btn large color="#1a73e8" dark class="px-4" @click="CloseSuccess">
                Great
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-dialog>

    <!-- <div
      id="attendeeAddEditSuccess"
      class="modal fade ss-success-modal"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <img src="../assets/Images/reg-ico/success.png" alt="e2m" />
            <h2 class="my-5">The new speaker has been created successfully!</h2>
            <div class="ss-cns-foo-btn">
              <button
                type="button"
                class="btn btn-primary px-4"
                @click="CloseSuccess"
              >
                Great
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Change Banner Modal -->
    <!-- <div class="modal fade changebannerpop" id="ChangeBannerModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          
          <div class="modal-body p-5 position-relative">
            <div class="banner-change-head ">
              <div>
                <h3>Add Banner</h3>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              </div>
              <span data-dismiss="modal" aria-label="Close"><v-icon color="#333" size="25px">mdi-close</v-icon></span>
            </div>
            <v-row>
              <v-col cols="12" md="6" sm="12" class="mt-8">
                <h5 class="mb-2">Upload banner</h5>
                <div class="changebanner-wrap">
                  <div class="change-banner-drop-sec">
                    <img src="../assets/Images/reg-ico/img-icon.svg"/>
                    <div class="trash-upload">
                      <span><v-icon color="#fff" size="25px">mdi-trash-can-outline</v-icon></span>
                    </div>
                  </div>
                  <div class="drop-image-desc">
                    <h5>Drag &amp; drop or <a href="#">Browse</a> to add Banner</h5>
                    <p>Supported image formats: PNG, JPG <br/>and recommended image dimension 2048/88 Max file size 1MB</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="12" class="mt-8">
                <h5 class="mb-2">Upload preview image</h5>
                <div class="changebanner-wrap">
                  <div class="change-banner-drop-sec">
                    <img src="../assets/Images/reg-ico/img-icon.svg"/>
                    <div class="trash-upload">
                      <span><v-icon color="#fff" size="25px">mdi-trash-can-outline</v-icon></span>
                    </div>
                  </div>
                  <div class="drop-image-desc">
                    <h5>Drag &amp; drop or <a href="#">Browse</a> to add preview image</h5>
                    <p>Supported image formats: PNG, JPG <br/>and recommended image dimension 1200/600 Max file size 1MB</p>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="save-settings d-flex justify-content-end align-items-center mt-10">
              <v-btn outlined class="mr-3" color="#333" width="120px" data-dismiss="modal">Cancel</v-btn>
              <v-btn dark color="#1a73e8" width="120px" data-dismiss="modal">Save</v-btn>
            </div>
          </div>
          
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
// import db from "../components/firebaseInit";
import APIs from "@/components/APIInit";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;

import SpeakerList from "@/views/SpeakerList.vue";
import SpeakerAddEdit from "@/views/SpeakerAddEdit.vue";

var vm;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import ReminderAnnounceMailPopup from "@/views/ReminderAnnounceMailPopup.vue";
import BulkUpload from "@/views/BulkUpload.vue";
import axios from "axios";
import { bus } from "@/main";
Vue.use(VueMoment, {
  moment,
});

export default {
  components: {
    SpeakerList,
    SpeakerAddEdit,
    ReminderAnnounceMailPopup,
    BulkUpload,
  },
  props: {
    isRegistrationComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      speakerAddEditDialog: false,
      uid: "",
      clientId: "",
      eventId: "",
      event_collectionName: "",
      isAdminComponent: true,
      speeakerListKey: 0,
      speeakerAddEditKey: 0,
      speeakerAddEditDialog: false,
      // BannerURL: "",
      // mobileBanner: "",
      // desktopBanner: "",
      Speaker: {},
      openBulkPopup: false,
      resetBulkUploadComponent: 0,
    };
  },
  computed: {},
  watch: {},
  created() {
    vm = this;
    //vm.initScreen();
    // $(window).resize(function () {
    //   vm.initScreen();
    // });
  },
  mounted() {
    vm.uid = vm.getSessionUserId();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.event_collectionName = vm.getEventCollectionName();
    if (vm.$route.hash == "#create") {
      vm.openSpeakerPopup();
    }

     bus.$on("openAddNewSpeakerPopup", () => {
      vm.openSpeakerPopup();
    });
    
  },
  methods: {
    // initScreen() {
    //   if (window.innerWidth > 768) {
    //     vm.BannerURL = vm.desktopBanner;
    //   } else {
    //     vm.BannerURL = vm.mobileBanner;
    //   }
    // },
    openSpeakerPopup() {
      vm.OpenAddSpeakerPopup();
    },
    openBulkUploadPopup() {
      vm.openBulkPopup = true;
      vm.resetBulkUploadComponent += 1;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    OpenAddSpeakerPopup(data) {
      this.Speaker = data;
      vm.speeakerAddEditDialog = true;
      vm.speeakerAddEditKey++;
      this.$nextTick(() => {
        $("#speakerAddEdit").modal("show");
      });
    },
    CloseAddAttendeePopup() {
      vm.speeakerAddEditKey++;
      vm.speeakerAddEditDialog = false;
      $("#speakerAddEdit").modal("hide");
    },
    OnAddSpeakerSuccess() {
      vm.CloseAddAttendeePopup();
      vm.OpenSuccess();
    },
    OnUpdateSpeakerSuccess() {
      vm.CloseAddAttendeePopup();
      vm.CloseSuccess();
      vm.showSnackbar("Speaker Updated Succesfully", "success", "top");
    },
    OpenSuccess() {
      vm.speakerAddEditDialog = true;
      // $("#attendeeAddEditSuccess").modal("show");
    },
    CloseSuccess() {
      vm.speakerAddEditDialog = false;
      //$("#attendeeAddEditSuccess").modal("hide");
      vm.speeakerListKey++;
    },
    updateSpeakerData(field) {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: field,
      };
      axios
        .put(APIs.AddSpeaker, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.status == 200) {
            vm.showSnackbar("Data Updated Succesfully.", "success", "top");
          } else {
            vm.showSnackbar("Data Not Updated!", "error", "top");
          }
        })
        .catch(function (error) {
          bus.$emit("toggleLoader", false);
          vm.showSnackbar("Something went wrong", "error", "top");
          console.log("Error adding attendee:", error);
        });
    },
  },
};
</script>
